import React, { type FC } from 'react';

import { Stack } from '@/components/layout';
import { Button, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { TouchableOpacity } from 'react-native';

type MutatePlayerFooterProps = {
  isTablet: boolean;
  insetBottom: number;
  onSave: () => void;
  onCancel: () => void;
  onDelete?: () => void;
  saveDisabled?: boolean;
  mode: 'create' | 'edit';
};

export const MutatePlayerFooter: FC<MutatePlayerFooterProps> = ({
  isTablet,
  insetBottom,
  onSave,
  onCancel,
  onDelete,
  saveDisabled = false,
  mode,
}) => {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack
      backgroundColor={colors['0']}
      paddingTop={scale(16)}
      paddingBottom={insetBottom + scale(12) + (onDelete ? scale(10) : 0)}
      paddingX={scale({ phone: 40, tablet: 0 })}
      // width={isTablet ? scale(676) : undefined}

      style={styles.footer}>
      <Stack
        direction={isTablet ? 'row' : 'column'}
        alignSelf={isTablet ? 'center' : undefined}
        maxWidth={isTablet ? scale(676) : undefined}
        width={isTablet ? '100%' : undefined}
        gap={scale(isTablet ? 20 : 16)}>
        <Button
          onPress={onSave}
          disabled={saveDisabled}
          style={[styles.primaryButton, ...(isTablet ? [styles.tabletFooterButton] : [])]}>
          <Button.Text variant={'Font Inter/Subtitle/Regular'}>
            {mode === 'edit'
              ? STRINGS.player.mutatePlayer.footer.saveChanges
              : STRINGS.player.mutatePlayer.footer.save}
          </Button.Text>
        </Button>

        <Button
          onPress={onCancel}
          variant="outline"
          style={[styles.secondaryButton, ...(isTablet ? [styles.tabletFooterButton] : [])]}>
          <Button.Text style={styles.cancelText} variant={'Font Inter/Subtitle/Regular'}>
            {STRINGS.player.mutatePlayer.footer.cancel}
          </Button.Text>
        </Button>
      </Stack>

      {onDelete && !isTablet ? (
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={onDelete}
          style={[styles.deleteWrap, isTablet && styles.deleteWrapTablet]}>
          <Text
            variant={isTablet ? 'Font Inter/Subtitle/Medium 14px' : 'Font Inter/Subtitle/Bold 10px'}
            style={styles.deleteText}>
            {STRINGS.player.mutatePlayer.footer.deletePlayer}
          </Text>
        </TouchableOpacity>
      ) : null}
    </Stack>
  );
};

const useStyles = createStyles(({ scale }) => ({
  footer: {
    borderTopWidth: scale(1),
    borderTopColor: colors['5'],
  },
  cancelText: {
    textTransform: 'uppercase',
  },
  primaryButton: {
    minHeight: scale(30),
    height: scale(30),
    paddingVertical: scale(0),
  },
  secondaryButton: {
    minHeight: scale(30),
    height: scale(30),
    paddingVertical: scale(0),
  },
  tabletFooterButton: {
    flex: 1,
    minHeight: scale(40),
    height: scale(40),
  },
  deleteWrap: {
    marginTop: scale(20),
    alignSelf: 'center',
  },
  deleteWrapTablet: {
    marginTop: scale(20),
  },
  deleteText: {
    color: colors.Red,
  },
}));
